import "./src/styles/global.scss"
require("prismjs/themes/prism-okaidia.css");

// or:
// require('./src/styles/global.css')